/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useState, useEffect } from 'react';
import Breadcrumb from '../common/breadcrumb';
import { Button, CardBody, Col, Container, Row } from 'reactstrap';
import { adminInstance } from '../../config/axios';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import defaultproductimg from '../../assets/images/product-list/1.jpg';
import { queryString } from './../../utils/queryString';
import { useSelector, useDispatch } from 'react-redux';
import FilterProductFields from '../FilterProductComp';
import {
  resetProducts,
  getAllRustItems,
  getRakeInventoryList,
  getAllTeamsData,
} from '../../reducers/adminReducers';
import ReactPaginate from 'react-paginate';
import Loader from '../loader/loader';
import PriceUpdatePopup from './PriceUpdate';
import AddRakeItemConfirmPopup from '../common/addRakeInventoryItemIntoProduct';
import { RustyRoyalCoin } from '../../utils/SvgIcons';
const List_rake_inventory = () => {
  const { id } = queryString();
  const newId = id ? id : '';
  const searchInitialObj = {
    title: '',
    min: '',
    max: '',
    category: '',
    rarity: '',
    skip: 0,
    limit: 10,
    partnerId: newId,
    gameId: '730',
  };

  const history = useHistory();
  const dispatch = useDispatch();
  const result = useSelector((state) => state.admin);
  const {
    selectedCategory,
    rakeInventoryList,
    selectedRarity,
    totalRakeInventoryCount,
    allTeamData,
  } = result || {};
  console.log('allTeamData=====>', allTeamData);

  const [open, setOpen] = useState(false);
  const [dummy, setDummy] = useState(false);
  const [loader, setLoader] = useState(false);
  const [searchPayload, setSearchPayload] = useState(searchInitialObj);
  const pageCount = Math.ceil(totalRakeInventoryCount / searchInitialObj.limit);
  const [priceOpen, setPriceOpen] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedAdmin, setSelectedAdmin] = useState('superAdmin');

  const getAllTeamdata = async () => {
    await dispatch(getAllTeamsData());
  };
  useEffect(() => {
    dispatch(getRakeInventoryList(searchPayload));
    getAllTeamdata();
  }, [dummy]);

  const handleSelect = (id) => {
    if (selectedItems.includes(id)) {
      setSelectedItems(selectedItems.filter((itemId) => itemId !== id));
    } else {
      setSelectedItems([...selectedItems, id]);
    }
  };

  const handleConfirm = async () => {
    try {
      setDummy(false);
      setOpen(false);
      const response = await adminInstance().post(
        `/api/admin/addMultiRakeItemToProduct`,
        { selectedRakeItems: selectedItems, selectedAdmin }
      );
      console.log('response===d=d=====sd==d====d=d=d=d===>>', response);
      const { code, msg } = response.data;
      if (code === 200) {
        setDummy(true);
        toast.success(msg, { toastId: 1 });
        setSelectedItems([]);
      } else {
        setDummy(false);
      }
    } catch (error) {
      setDummy(false);
      toast.error('Something went wrong', { toastId: 1 });
    }
  };

  const onCloseModal = () => {
    setOpen(false);
  };

  const onClosePriceModal = () => {
    setPriceOpen(false);
  };

  const handleAddToProduct = () => {
    setOpen(true);
  };

  const handleSearchProduct = async (e) => {
    dispatch(resetProducts());
    const { value, name } = e.target;
    console.log(value, name);
    const copySearchPayLoad = { ...searchPayload };
    copySearchPayLoad[name] = value;
    copySearchPayLoad.skip = 0;
    setSearchPayload(copySearchPayLoad);
    dispatch(getRakeInventoryList(copySearchPayLoad));
  };

  const handlePageClick = ({ selected }) => {
    const copySearchPayLoad = { ...searchPayload };
    copySearchPayLoad.skip = selected * searchPayload.limit;
    setSearchPayload(copySearchPayLoad);
    dispatch(getRakeInventoryList(copySearchPayLoad));
  };

  const handleGetRustItems = () => {
    setLoader(true);
    const copySearchPayLoad = { ...searchPayload };
    copySearchPayLoad.skip = 0;
    dispatch(getAllRustItems(copySearchPayLoad)).then((response) => {
      if (response?.payload?.resultData?.data?.code === 200) {
        setLoader(false);
      }
    });
  };

  const handleGameSelect = (item) => {
    setLoader(true);
    const copySearchPayLoad = { ...searchPayload };
    copySearchPayLoad.gameId = item.target.value;
    setSearchPayload(copySearchPayLoad);
    dispatch(getRakeInventoryList(copySearchPayLoad)).then((response) => {
      if (response?.payload?.resultData?.data?.code === 200) {
        setLoader(false);
      }
    });
  };

  const sanitizeImageUrl = (url) => {
    if (!url) return '';
    const parts = url.split('https://').filter(Boolean);
    return parts.length > 1 ? `https://${parts[parts.length - 1]}` : url;
  };

  const handleComparePrice = () => {
    history.push(
      `/products/compare-product-price?gameId=${searchPayload?.gameId}`
    );
  };

  const handleSelectedAdminChange = (event) => {
    setSelectedAdmin(event.target.value);
    console.log('Selected category:', event.target.value);
  };
  return (
    <Fragment>
      <Breadcrumb title='Rake Inventory' parent='Physical' />
      <Container fluid={true}>
        <FilterProductFields
          rarityList={selectedRarity}
          handleSearchProduct={handleSearchProduct}
          categoryList={selectedCategory}
          handleGetRustItems={handleGetRustItems}
          handleGameSelect={handleGameSelect}
          handleComparePrice={handleComparePrice}
          isInventory={true}
        />
        {selectedItems.length > 0 && (
          <div className='mb-3' style={{ marginTop: '20px' }}>
            <Button color='primary' onClick={handleAddToProduct}>
              Move to Admin Inventory {selectedItems.length} Items
            </Button>
          </div>
        )}
        {loader ? (
          <Loader />
        ) : (
          <>
            <Row className='products-admin ratio_asos product-list-page'>
              {rakeInventoryList && rakeInventoryList.length === 0 && (
                <p className='not-found-text'>No Product Found</p>
              )}
              {rakeInventoryList &&
                rakeInventoryList.map((myData, i) => {
                  const color = myData?.color;
                  const isSelected = selectedItems.includes(myData._id);

                  return (
                    <Col xl='3' sm='6' key={i}>
                      <div
                        className={`products-admin ${
                          isSelected ? 'selected' : ''
                        }`}
                        onClick={() => handleSelect(myData._id)}
                        style={{
                          cursor: 'pointer',
                          border: isSelected
                            ? '2px solid rgb(0, 214, 114)'
                            : '2px solid #ffffff',
                          borderRadius: '8px',
                          marginBottom: '10px',
                          overflow: 'hidden',
                        }}
                      >
                        <CardBody className='product-box mb-0'>
                          <div
                            className='img-wrapper'
                            style={{
                              background: `linear-gradient(180deg, ${color}bf 50%, ${color} 100%)`,
                            }}
                          >
                            <div className='front product-image'>
                              <div className='bg-size'>
                                <img
                                  alt=''
                                  className='img-fluid blur-up bg-img lazyloaded product-img'
                                  src={
                                    myData?.bannerImage
                                      ? sanitizeImageUrl(myData?.bannerImage)
                                      : defaultproductimg
                                  }
                                />
                              </div>
                            </div>
                          </div>
                          <div className='product-detail'>
                            <div className='pro_contents'>
                              <div className='pro_name'>
                                <h6>
                                  {myData.name || myData?.market_hash_name}
                                </h6>
                              </div>
                              <div className='price_legen'>
                                <p>{myData?.name}</p>
                                <h4 className='d-flex'>
                                  <p
                                    className='m-0'
                                    style={{ marginTop: '-7px' }}
                                  >
                                    <RustyRoyalCoin size={20} />
                                  </p>
                                  <div className='px-1'>
                                    {myData.price.toFixed(2)}
                                  </div>
                                </h4>
                              </div>
                            </div>
                          </div>
                        </CardBody>
                      </div>
                    </Col>
                  );
                })}
            </Row>
          </>
        )}
        <Row>
          <Col className='d-flex justify-content-center pb-3 mt-3'>
            <div class='text-center search-pagination'>
              <ReactPaginate
                breakLabel='...'
                nextLabel=''
                onPageChange={handlePageClick}
                pageRangeDisplayed={10}
                pageCount={pageCount}
                previousLabel=''
                renderOnZeroPageCount={null}
              />
            </div>
          </Col>
        </Row>
      </Container>
      <AddRakeItemConfirmPopup
        open={open}
        handleConfirm={handleConfirm}
        onCloseModal={onCloseModal}
        selectedAdmin={selectedAdmin}
        handleSelectedAdminChange={handleSelectedAdminChange}
        allTeamData={allTeamData}
      />
      <PriceUpdatePopup
        onCloseModal={onClosePriceModal}
        title={'Update Price'}
        open={priceOpen}
        setDummy={setDummy}
        // currentProduct={currentProduct}
      />
    </Fragment>
  );
};

export default List_rake_inventory;
